export default __webpack_public_path__ + "static/media/MyStats.55f1e84c.svg";